<a
  class="flex items-center px-6 py-4 focus:outline-none focus:shadow-inner-lighter-blue md:px-0 md:flex-col"
  rel="noopener noreferrer"
  target="_blank"
  [href]="location">
  <img appImg class="w-6 h-6 fill-current" [src]="iconPath" />
  <span class="ml-2 md:ml-0 md:mt-1"><ng-content></ng-content> </span>
</a>
